import { isElementIntoView } from './helpers/common-helpers';

window.addEventListener('DOMContentLoaded', () => {
    isElementIntoView('.js-animated', async _ => {
        const clientLists = [...document.querySelectorAll('.js-animated')];

        if (clientLists.length) {
            clientLists.forEach((client) => {
                client.classList.add('is-animated');
            })
        }
    });
});
